// @ts-nocheck
import React from "react";
import scopeTab from "./helpers/scopeTab.js";
import * as focusManager from "./helpers/focusManager";
import * as classList from "./helpers/classList";
const TAB_KEY = 9;
const ESC_KEY = 27;

type ClassNamesType = {
  [type: string]: string;
};

const CLASS_NAMES: ClassNamesType = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

/**
 * @description IModalDialogProps Property type definition
 * @interface IModalDialogProps
 */
interface IModalDialogProps {
  isOpen: boolean;
  role?: string;
  //className?: string | undefined;
  className?: any;
  portalClassname?: string;
  htmlOpenClassName?: string;
  bodyOpenClassName?: string;
  //backgroundClassName?: string | undefined;
  backgroundClassName?: any;
  closeTimeoutMS?: number;
  onAfterOpen?: any; // func
  onAfterClose?: any; //func
  onRequestClose?: any; //func
  defaultStyles?: any;
  style?: any;
}

/**
 * @description ModalDialog States type definitiion
 * @interface IModalDialogState
 */
interface IModalDialogState {
  beforeClose: boolean;
  afterOpen: boolean;
  isOpen: boolean;
  closesAt: any;
}

/**
 * @description Modal 타입의 다이얼로그 UI
 * 모달이기 때문에 다이얼로그 출력시 다이얼로그 이외 동작을 차단하기 위해서 다이얼로그 element이외에
 * 배경 element도 함께 생성한다.
 * @export
 * @class ModalDialog
 * @extends {React.Component<IModalDialogProps, IModalDialogState>}
 */
export default class ModalDialog extends React.Component<
  IModalDialogProps,
  IModalDialogState
> {
  /// 다이얼로그 내부에 그려질 Children의 root element
  private contentElementRef: any = null;
  /// 모달 특성 구현을위해 다이얼로그 뒷편에 생성되는 배경 DIV Element
  private backgroundElementRef: any = null;
  private closeTimer: any = null;
  /// 배경영역 클릭시, 다이얼로그가 닫혀야하는지 판단 변수
  private shouldClose: any = null; /// react 철학과는 맞지않는듯하다.
  // private closeTimeoutMS: number = 0;
  /// 이변수를 어떻게 할지 좀 생각해보자

  public static defaultProps = {
    isOpen: false,
    defaultStyles: {},
    style: {
      overlay: {},
      content: {}
    },
    closeTimeoutMS: 0
  };
  constructor(props: any) {
    super(props);
    this.state = {
      beforeClose: false,
      afterOpen: false,
      isOpen: false,
      closesAt: null
    };
  }

  /**
   *
   *
   * @memberof ModalDialog
   */
  componentDidMount() {
    const { isOpen } = this.props;
    if (isOpen) {
      this.open();
    }
  }

  /**
   *
   *
   * @param {*} prevProps
   * @param {*} prevState
   * @memberof ModalDialog
   */
  componentDidUpdate(prevProps: any, prevState: any) {
    const { isOpen } = this.props;
    const { prevIsOpen } = prevProps;

    if (isOpen && !prevIsOpen) {
      this.open();
    } else if (!isOpen && prevIsOpen) {
      this.close();
    }

    // 다이얼로그가 렌더링된 후 포커스를 다이얼로그로 이동
    if (this.state.isOpen && prevState.isOpen) {
      this.focusOn();
    }
  }

  /**
   *
   *
   * @memberof ModalDialog
   */
  componentWillUnmount() {
    this.afterClose();
    clearTimeout(this.closeTimer);
  }

  /**
   *
   *
   * @memberof ModalDialog
   */
  beforeOpen = () => {
    const { htmlOpenClassName, bodyOpenClassName } = this.props;
    // Add classes.
    bodyOpenClassName && classList.add(document.body, bodyOpenClassName);
    htmlOpenClassName &&
      classList.add(
        document.getElementsByTagName("html")[0],
        htmlOpenClassName
      );
  };
  /**
   *
   *
   * @memberof ModalDialog
   */
  open = () => {
    this.beforeOpen();
    const { afterOpen, beforeClose } = this.state;
    if (afterOpen && beforeClose) {
      clearTimeout(this.closeTimer);
      //this.setState({ beforeClose: false });
      (this.state.beforeClose as any) = false;
    } else {
      focusManager.setupScopedFocus(this.contentElementRef);
      focusManager.markForFocusLater();
      (this.state.afterOpen as any) = false;
      (this.state.isOpen as any) = true;

      if (this.props.isOpen && this.props.onAfterOpen) {
        this.props.onAfterOpen();
      }
    }
  };

  /**
   *
   *
   * @memberof ModalDialog
   */
  afterClose = () => {
    const { htmlOpenClassName, bodyOpenClassName, onAfterClose } = this.props;
    // Remove classes.
    bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);

    htmlOpenClassName &&
      classList.remove(
        document.getElementsByTagName("html")[0],
        htmlOpenClassName
      );

    focusManager.returnFocus();
    focusManager.teardownScopedFocus();

    if (onAfterClose) {
      onAfterClose();
    }
  };

  close = () => {
    const { closeTimeoutMS } = this.props;
    if (closeTimeoutMS !== undefined && closeTimeoutMS > 0) {
      this.closeWithTimeout();
    } else {
      this.closeWithoutTimeout();
    }
  };

  /**
   * @description 배경 영역에 발생한 Click 이벤트 처리 핸들러
   * Owner로부터 닫기 callback 함수를 받은 경우 닫기 요청
   * 없다면, focusOn 수행
   *
   * @memberof ModalPortal
   */
  handleBackgroundClick = (event: any) => {
    if (this.shouldClose === null) {
      this.shouldClose = true;
    }

    const { onRequestClose } = this.props;

    if (this.shouldClose) {
      if (onRequestClose) {
        this.requestCloseToOwner(event);
      } else {
        this.focusOn();
      }
    }

    this.shouldClose = null;
  };

  /**
   * @description 배경 영역에 발생한 MouseDown 이벤트 처리 핸들러
   * 상위 Element로 전달되는 이벤트 버블을 차단
   *
   * @memberof ModalPortal
   */
  handleBackgroundMouseDown = (event: any) => {
    if (event.target === this.backgroundElementRef) {
      event.preventDefault();
    }
  };

  /**
   * @description 다이얼로그 영역에 발생한 MouseDown/Up/Click 이벤트 처리 핸들러
   * 다이얼로그 영역 클릭으로 인해 다이얼로그가 닫히지 않게 함.
   *
   * @memberof ModalPortal
   */
  handleContentClick = () => (this.shouldClose = false);
  handleContentMouseDown = () => (this.shouldClose = false);
  handleContentMouseUp = () => (this.shouldClose = false);
  /**
   * @description keydown 이벤트 처리 핸들러
   * Tab키 입력시 Tab이동, ESC키 입력시 다이얼로그 닫기
   *
   * @memberof ModalPortal
   */
  handleKeyDown = (event: any) => {
    const isTabKeyDown = event.keyCode === TAB_KEY;
    if (isTabKeyDown) {
      // todo move focus
      scopeTab(this.contentElementRef, event);
    }

    const isEscKeyDown = event.keyCode === ESC_KEY;
    if (isEscKeyDown) {
      event.stopPropagation();
      this.requestCloseToOwner(event);
    }
  };

  /**
   *
   *
   * @memberof ModalDialog
   */
  closeWithTimeout = () => {
    const { closeTimeoutMS } = this.props;
    if (closeTimeoutMS === undefined || closeTimeoutMS === null) {
      return;
    }
    const closesAt = Date.now() + closeTimeoutMS;
    this.setState({ beforeClose: true, closesAt }, () => {
      this.closeTimer = setTimeout(
        this.closeWithoutTimeout,
        this.state.closesAt - Date.now()
      );
    });
  };

  /**
   *
   *
   * @memberof ModalDialog
   */
  closeWithoutTimeout = () => {
    this.setState(
      {
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      },
      this.afterClose
    );
  };

  /**
   * @description BaseDialog의 Owner에게 다이얼로그 닫기 요청
   *
   * @memberof ModalPortal
   */
  requestCloseToOwner = (event: any) => {
    const { onRequestClose } = this.props;
    onRequestClose && this.props.onRequestClose(event);
  };

  /**
   *
   *
   * @memberof ModalDialog
   */
  focusOn = () => {
    this.contentElementRef &&
      !this.hasFocus() &&
      this.contentElementRef.focus();
  };

  /**
   *
   *
   * @memberof ModalDialog
   */
  hasFocus = () => {
    if (
      document.activeElement === this.contentElementRef ||
      this.contentElementRef.contains(document.activeElement)
    ) {
      return true;
    }
    return false;
  };

  /**
   *
   *
   * @memberof ModalDialog
   */
  setBackgroundElementRef = (ref: HTMLDivElement) => {
    this.backgroundElementRef = ref;
  };

  /**
   *
   *
   * @memberof ModalDialog
   */
  setContentElementRef = (ref: HTMLDivElement) => {
    this.backgroundElementRef = ref;
  };
  /**
   *
   *
   * @memberof ModalDialog
   */
  buildClassName = (which: string, additional: string) => {
    const classNames =
      typeof additional === "object"
        ? additional
        : {
            base: CLASS_NAMES[which],
            afterOpen: `${CLASS_NAMES[which]}--after-open`,
            beforeClose: `${CLASS_NAMES[which]}--before-close`
          };
    let className = classNames.base;
    if (this.state.afterOpen) {
      className = `${className} ${classNames.afterOpen}`;
    }
    if (this.state.beforeClose) {
      className = `${className} ${classNames.beforeClose}`;
    }
    return typeof additional === "string" && additional
      ? `${className} ${additional}`
      : className;
  };

  /**
   *
   *
   * @memberof ModalDialog
   */
  render = () => {
    const {
      children,
      role,
      className,
      backgroundClassName,
      defaultStyles,
      style
    } = this.props;
    const beClose = !this.props.isOpen && !this.state.beforeClose;
    /// className이 있다면, content에 default style을 적용하지 않는다.
    const contentStyles = className ? {} : defaultStyles.content;
    /// backgroundClassName이 있다면, content에 default style을 적용하지 않는다.
    const backgroundStyles = backgroundClassName ? {} : defaultStyles.overlay;

    return beClose ? null : (
      <div
        ref={this.setBackgroundElementRef}
        className={backgroundClassName}
        style={{ ...backgroundStyles, ...style.overlay }}
        onClick={this.handleBackgroundClick}
        onMouseDown={this.handleBackgroundMouseDown}
      >
        <div
          ref={this.setContentElementRef}
          style={{ ...contentStyles, ...style.content }}
          className={
            className
              ? className
              : this.buildClassName("content", className as any)
          }
          tabIndex={-1}
          onKeyDown={this.handleKeyDown}
          onMouseDown={this.handleContentMouseDown}
          onMouseUp={this.handleContentMouseUp}
          onClick={this.handleContentClick}
          role={role}
        >
          {children}
        </div>
      </div>
    );
  };
}
